import { AmmunitionStockService } from '../model/ammunition-stock.service';
import { CrudDataSource, HateoasMultipleResponseObject, PageSpecification } from '@scisys-uim/uim-common';
import { AmmunitionStock } from 'assets-model';
import { Observable } from 'rxjs';


export class AmmunitionStockDataSource extends CrudDataSource<AmmunitionStock> {

  constructor(private service: AmmunitionStockService) {
    super();
  }

  protected callLoaderService(serviceArguments: any, pageSpec: PageSpecification, withStockCalculations: boolean = true): Observable<HateoasMultipleResponseObject<AmmunitionStock>> {
    return this.service.findByFullFilters(serviceArguments, pageSpec, withStockCalculations);
  }

}


